module.exports = __webpack_public_path__ + "img/esim_area_zh-tw.109e4385.png";